import { render, staticRenderFns } from "./UpdateClassRoom.vue?vue&type=template&id=7836ad95&scoped=true&"
import script from "./UpdateClassRoom.vue?vue&type=script&lang=js&"
export * from "./UpdateClassRoom.vue?vue&type=script&lang=js&"
import style0 from "./UpdateClassRoom.vue?vue&type=style&index=0&id=7836ad95&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7836ad95",
  null
  
)

export default component.exports